<div class="column-chart-placeholder">
  <chart class="chart-container" [options]="options">
  </chart>
</div>



// WEBPACK FOOTER //
// ./src/app/core/achoo-column-chart-placeholder/achoo-column-chart-placeholder.component.html